import { trpc } from '@/shared/api';

interface InvalidateInkColors {
  /** 마스터 목록만 — 잉크 추가. 새 잉크는 어느 상품에도 허용되지 않은 채 시작한다. */
  readonly list: () => void;
  /** 한 상품의 허용 목록 — 상품 편집 화면의 허용 잉크 저장. */
  readonly forProduct: (productId: string) => void;
  /**
   * 마스터 목록·모든 상품의 허용 목록·id 이름 찾기 — 이름 변경·삭제. 삭제는 모든 상품에서 연결을 지우므로,
   * 상품 화면에 지운 잉크가 남은 채 저장하면 400 이다(staleTime 동안 옛 목록이 보이지 않게).
   * 견적 상세의 잉크 이름·'(삭제됨)' 표시도 바로 바뀐다.
   */
  readonly afterMasterChange: () => void;
}

/** 잉크 색상 캐시 무효화 묶음 — useInvalidateFonts 와 대칭. */
export const useInvalidateInkColors = (): InvalidateInkColors => {
  const utils = trpc.useUtils();
  const inkColors = utils.productManagement.inkColors;

  return {
    list: () => void inkColors.list.invalidate(),
    forProduct: (productId) => void inkColors.listForProduct.invalidate({ productId }),
    afterMasterChange: () => {
      void inkColors.list.invalidate();
      void inkColors.listForProduct.invalidate();
      void inkColors.listByIds.invalidate();
    },
  };
};
